import { render, staticRenderFns } from "./forceTypeAdd.vue?vue&type=template&id=6204ae35&scoped=true"
import script from "./forceTypeAdd.vue?vue&type=script&lang=js"
export * from "./forceTypeAdd.vue?vue&type=script&lang=js"
import style0 from "./forceTypeAdd.vue?vue&type=style&index=0&id=6204ae35&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6204ae35",
  null
  
)

export default component.exports